import * as Yup from 'yup'

import { passwordYupShape } from 'common/password-validation'

export const parentYupValidation = Yup.object().shape({
  firstName: Yup.string().required('First Name is Required.'),
  lastName: Yup.string().required('Last Name is Required.'),
  password: Yup.object().shape(passwordYupShape()),
})
